import momentImport from 'moment/moment.js';
import 'momentLocale/nb';
import 'momentLocale/en-gb';

type MomentStatic = typeof momentImport extends {default: infer M} ? M : typeof momentImport;

/** Unwrap CJS/UMD default interop so locale() and other statics are callable. */
const moment = ((momentImport as {default?: MomentStatic}).default ?? momentImport) as MomentStatic;

export {moment};
export default moment;
